type AuthEvent = "UNAUTHORIZED";

const authEventTarget = new EventTarget();

export const emitAuthEvent = (event: AuthEvent) => {
  authEventTarget.dispatchEvent(new Event(event));
};

export const onAuthEvent = (event: AuthEvent, callback: () => void) => {
  const handler = () => callback();
  authEventTarget.addEventListener(event, handler);

  return () => authEventTarget.removeEventListener(event, handler);
};
